import store from '../store'
import Request from './request';
import consts from "@/consts.js";
import i18n from '@/i18n';
import snackbar from '@/plugins/snackbar';

async function fetch(data) {
    return Request('get', "api/distributions", data);
}

async function fetchOne(id, data) {
    return Request('get', "api/distributions/view?id=" + id, data);
}

async function distributionPrint(id) {// 打印配送单
    return Request('get', "api/distributions/print/" + id)
}

async function distributionsPrint(data) {// 批量打印配送单
    data.limit = consts.limitAll; //获取全部
    data.itemsPerPage = consts.limitAll; //获取全部
    return Request('get', "api/distributions/prints", data)
}

async function checkExpress(id) {
    return Request('get', "api/distributions/check-express?id=" + id);
}

async function distribute(id) {
    return Request('get', "api/distributions/distribute?id=" + id);
}

async function editLogistic(data) {
    return Request('patch', "api/distributions/edit-logistics", data);
}

async function batchDistribute(data) { //批量出库
    return Request('get', "api/distributions/batch-distribute", data, false, false, true)
}

async function expressExport(data) {// 批量导出物流
    store.dispatch("fullscreenLoading");
    const response = await Request('get', "api/distributions/distribution-for-express-export", data)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t("Export.recordedHint"));
    }
    store.dispatch("fullscreenLoadingStop");
    return response;
}

async function expressImport(file) {// 物流导入
    var data = new FormData();
    data.append("excel", file);
    return Request('post', "api/distributions/express-import",data)
}

async function shopDistributionsPrint(data) {// 配送单合并打印
    data.limit = consts.limitAll; //获取全部
    data.itemsPerPage = consts.limitAll; //获取全部
    return Request('get', "api/distributions/shopDistributionsPrint", data)
}

export default {
    fetch, 
    fetchOne,
    distributionPrint,
    distributionsPrint,
    checkExpress,
    distribute,
    editLogistic,
    batchDistribute,
    expressExport,
    expressImport,
    shopDistributionsPrint,
};